"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var fill = _ref.fill,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 1H4C4.5012 1 4.92499 1.37103 4.99123 1.86783L5.27552 4H22C22.2921 4 22.5696 4.12768 22.7595 4.3495C22.9495 4.57133 23.033 4.86512 22.9881 5.15371L21.8514 12.4611C21.6241 13.9224 20.3659 15 18.8871 15H6.74221L6.87554 16H18C18 16 18 16 18 16C19.6568 16 21 17.3432 21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 18.6494 15.0602 18.3128 15.1707 18H9.82929C9.93985 18.3128 10 18.6494 10 19C10 20.6569 8.65685 22 7 22C5.34315 22 4 20.6569 4 19C4 18.129 4.37121 17.3446 4.96405 16.7966L3.12449 3H1V1ZM18 18C17.4477 18 17 18.4477 17 19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19C19 18.4477 18.5523 18 18 18C18 18 18 18 18 18ZM6 19C6 18.4477 6.44772 18 7 18C7.55228 18 8 18.4477 8 19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19ZM6.47554 13H18.8871C19.38 13 19.7994 12.6408 19.8752 12.1537L20.8324 6H5.54219L6.47554 13Z",
      fill: fill
    })]
  }));
};

var _default = SvgShoppingCart;
exports["default"] = _default;